import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { fromDatestampArray } from '../time';
import { BillingStageType } from './model';
export function makeResponse(data) {
    return data || {};
}
export function make(billableState, periods, minDate, maxDate, billedAmount, billingStages) {
    return {
        periods,
        minDate,
        maxDate,
        billableState,
        billedAmount,
        billingStages: billingStages
    };
}
export function makeBilledStage(billedServiceStage) {
    switch(billedServiceStage.type){
        case BillingStageType.Scheduled:
            return _object_spread_props(_object_spread({}, billedServiceStage), {
                amount: new Decimal(billedServiceStage.amount)
            });
        case BillingStageType.Available:
            return _object_spread_props(_object_spread({}, billedServiceStage), {
                amount: new Decimal(billedServiceStage.amount)
            });
        case BillingStageType.Billed:
            return _object_spread_props(_object_spread({}, billedServiceStage), {
                amount: new Decimal(billedServiceStage.amount)
            });
    }
}
export function makePeriod(startDate, endDate, billedQuantity, scheduledQuantity) {
    return {
        startDate: Array.isArray(startDate) ? fromDatestampArray(startDate) : startDate,
        endDate: Array.isArray(endDate) ? fromDatestampArray(endDate) : endDate,
        billedQuantity: new Decimal(billedQuantity),
        scheduledQuantity: new Decimal(scheduledQuantity)
    };
}
